import React from 'react';
import { translate } from 'react-admin';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  link: {
    color: '#00A1A1 !important'
  }
}

const ConsentItemsCountField = translate(({record, translate, classes, basePath}) => {
  const {universalConsentItems, id} = record;
  const consentSolutionsCount = universalConsentItems.length;
  const text = translate('consent_items_count', {smart_count: consentSolutionsCount});
  const encodedID = encodeURIComponent(id);
  return (
    <Link to={{pathname:`${basePath}/${encodedID}`}} className={classes.link}>
      {text}
    </Link>
  )});

export default withStyles(styles)(ConsentItemsCountField);
